import { usageId } from '../../../../../constants/usageid.js';
import { ChartConfigurationSchemaIds, ChartConfigurationTags } from '../../schemas/configuration.const.js';
export const dictionary = {
    schema: {
        [usageId(ChartConfigurationSchemaIds.CHART_CONFIGURATION, ChartConfigurationTags.DEFAULT)]: {
            title: 'Chart Configuration',
            description: 'Options that apply to Charts.',
            abbr: 'Chart config.',
            cti: 'Set the Chart options.'
        }
    }
};
